import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { FieldArrayType, FormlyFieldConfig } from '@ngx-formly/core';
import { AbstractControl } from '@angular/forms';
import { forEach as _forEach, includes as _includes, filter as _filter,
uniqueId as _uniqueId, toNumber as _toNumber, isEmpty as _isEmpty, get as _get, 
map as _map, uniq as _uniq, groupBy as _groupBy, pull as _pull, 
cloneDeep as _cloneDeep, indexOf as _indexOf, orderBy as _orderBy, isUndefined as _isUndefined, 
sortBy as _sortBy, findIndex as _findIndex, concat as _concat, find as _find, size as _size} from 'lodash-es';
import { put } from 'src/app/connector-studio/utilities/helpers';
import { ShowSelectedTableCategoryPipe } from '../../pipes/show-selected-table-category/show-selected-table-category.pipe';
import { ActivatedRoute, Router } from '@angular/router';


export interface FormlyFieldConfigCustom extends Omit<FormlyFieldConfig, 'fieldArray'|'formControl'> {
  fieldArray?: FormlyFieldConfig
  formControl?: AbstractControl
}

export class RepeatType {
  name: string;
  props: { label?: string };
  fieldGroup: FormlyFieldConfigCustom[];
}

export interface RepeatFieldConfig extends FormlyFieldConfigCustom {
  types: RepeatType[];
  defaultTypes: string[];
}


@Component({
  selector: 'app-virtual-scroll-grid-field-type',
  templateUrl: './virtual-scroll-grid-field-type.component.html',
  styleUrls: ['./virtual-scroll-grid-field-type.component.scss'],
})
export class VirtualScrollGridFieldTypeComponent extends FieldArrayType<RepeatFieldConfig> implements OnInit, OnDestroy {
  
  selectAll: boolean = false;
  selectedItemNames: string[] = []
  searchString: string;
  categorizedTables: any;
  public tableCategoryVisibilityStrategy = new Set();
  selectedItemsCategoryMap: any = {};
  showSelectedTableCategoryPipe = new ShowSelectedTableCategoryPipe();
  tableNameCategoryMap: any = {}
  childParentTableMapping: any = {};
  parentChildTableMapping: any = {}
  orphanTablesName = `Zzzzzz`;
  orphanTablesVisibleName = `Others`;
  isTemplate: boolean = false;
  purposeType: string;
  purposeMode: string;

  constructor(
    private route: ActivatedRoute
  ){
    super();
  }

  ngOnInit() {
    if(this.route.data['_value']['mode'] === 'attach' || this.route.data['_value']['type'] === 'edit-attach'){
      this.isTemplate = true;
    }
    this.field.props.tableDeselectHandler = this.tableDeselectHandler.bind(this);
    this.generateTableNameCategoryMap();
    this.generateInitialSelectedItemsCategoryMap();
    this.categorizedTables = _groupBy(this.field.fieldArray.fieldGroup, item => {
      this.childParentTableMapping[item.name] = item.props.parentTable;
      return _get(item, 'props.category', 'no_category');
    });

    this.generateParentChildrenTableMapping()
    this.field.fieldArray.fieldGroup = _orderBy(this.field.fieldArray.fieldGroup, fieldGroup => {
      return fieldGroup.props.category
    }, ['asc'])
    
    if(!_isEmpty(this.model)) {
      _forEach(this.model, table => {
        this.selectedItemNames.push(table.name)
      })
      this.field.props.selectedItemNames = [...this.selectedItemNames]
    }

    if(!_isEmpty(this.field.fieldGroup)) {
      this.reorderFieldModel();
    }
    this.field.props.noTableSelected = _get(this.selectedItemNames, 'length') == 0;
    this.field.props.categorizedTables  = this.categorizedTables;
  }

  selectTable(table) {
    this.selectedItemNames.push(table.className)
    put(this.selectedItemsCategoryMap, `${table.props.category}[]`, table.className)
    this.field.props.selectedItemNames = [...this.selectedItemNames]
    this.updateSelectedItemsCategoryMap()
    this.add(null, {
      name: table.className,
      category: table.props.category
    });
    this.autoSelectParentTables(table)
    this.reorderFieldModel()
  }

  autoSelectParentTables(table) {
    const parentTables = _get(table, 'props.parentTable');
    const filteredTables = _filter(parentTables, parentTable => {
     return parentTable !== table.name && !_includes(this.selectedItemNames, parentTable);
    });

    if(!_isEmpty(filteredTables)) {
      _forEach(filteredTables, filteredTable => {
        this.selectedItemNames.push(filteredTable)
        this.field.props.selectedItemNames = [...this.selectedItemNames]
        const tableCategory = this.tableNameCategoryMap[filteredTable];
        put(this.selectedItemsCategoryMap, `${tableCategory}[]`, filteredTable)
        this.add(null, {
          name: filteredTable,
          category: tableCategory,
          autoAddedTo: [table.name],
          possibleChildren: _get(this.parentChildTableMapping, filteredTable)
        });
        if(!_isEmpty(this.childParentTableMapping[filteredTable])) {
          const getFromFieldArray = _find(this.field.fieldArray.fieldGroup, {name: filteredTable });
          this.autoSelectParentTables(getFromFieldArray)
        }
      })
      this.updateSelectedItemsCategoryMap();
      this.reorderFieldModel()
    }
  }

  toggleAllTableSelection(type) {
    
    const selectedItemNames = _map(
      _filter(_get(this.field, 'parent.model.tableSelection'), table => {
        return !_isEmpty(table);
      }), 'name')

    if(type === 'select') {
      const filteredFieldGroup = _filter(this.field.fieldArray.fieldGroup, group => {
        return !_includes(selectedItemNames, group.className)
      })
      _forEach(filteredFieldGroup, table => {
          this.selectedItemNames.push(table.className)
          put(this.selectedItemsCategoryMap, `${table.props.category}[]`, table.className)
          this.field.props.selectedItemNames = [...this.selectedItemNames]
          this.add(null, {
            name: table.className,
            category: table.props.category,
          });
      })
      this.updateSelectedItemsCategoryMap();
      this.reorderFieldModel()
    } else if(type === 'deselect') {
      this.field.fieldGroup = _orderBy(this.field.fieldGroup, fieldGroup => _toNumber(fieldGroup.key), ['asc']);
      const selectedItemNames = _uniq(this.selectedItemNames)
      _forEach(this.field.fieldGroup, (fieldGroup) => {
        this.remove(0)
      })
      
      this.selectedItemsCategoryMap = {}
      this.selectedItemNames = []
      this.field.props.selectedItemNames = [...this.selectedItemNames]
    }
  }

  filterTables(event) {
    this.searchString = event.target.value
  }

  tableDeselectHandler(fieldParent, field) {
    if(field.model.name === false) {
      _pull(this.selectedItemsCategoryMap[field.props.category], field.name)
      _pull(this.selectedItemNames, field.name)
      this.field.props.selectedItemNames = [...this.selectedItemNames]
      this.field.props.selectedItemsCategoryMap = {...this.selectedItemsCategoryMap}
      this.remove(fieldParent.key)
      this.reorderFieldModel()
    }
  }

  generateInitialSelectedItemsCategoryMap() {
    _forEach(this.field.fieldGroup, (fieldGroup) => {
      put(this.selectedItemsCategoryMap, `${this.tableNameCategoryMap[fieldGroup.model.name]}[]`, fieldGroup.model.name)
    })
    this.updateSelectedItemsCategoryMap()
  }

  generateTableNameCategoryMap() {
    let noOfOrphanTables = 0
    _forEach(this.field.fieldArray.fieldGroup, (fieldGroup) => {
      if(fieldGroup.props.category)
        this.tableNameCategoryMap[fieldGroup.name] = fieldGroup.props.category
      else
        noOfOrphanTables++
    })
    if(noOfOrphanTables > 0 && noOfOrphanTables !== _size(this.field.fieldArray.fieldGroup)){
      _forEach(this.field.fieldArray.fieldGroup, (fieldGroup) => {
        if(!fieldGroup.props.category){
          this.tableNameCategoryMap[fieldGroup.name] = fieldGroup.props.category =  this.orphanTablesName
          fieldGroup.props.label = this.orphanTablesVisibleName
        }
      })
    }
  }

  reorderFieldModel() {
    const orderedModel = _orderBy(this.model, (item) => {
      item.category = this.tableNameCategoryMap[item.name];
      item.possibleChildren = _get(this.parentChildTableMapping, item.name)
      return item.category;
    }, ['asc'])    

    // Empty the model
    this.model.splice(0, this.model.length) 
    // Reassign the model with descending order table category
    this.model.splice(0, 0, ...orderedModel); 
    // Empty the fieldGroup
    this.field.fieldGroup = []
    //Rebuild the form based on the model
    this.field.options.build()
  }

  updateSelectedItemsCategoryMap() {
    this.field.props.selectedItemsCategoryMap = {...this.selectedItemsCategoryMap}
  }

  setTableCategoryToFieldGroupModel() {
    _forEach(this.field.fieldGroup, fieldGroup => {
      fieldGroup.model.category = this.tableNameCategoryMap[fieldGroup.model.name];
    })
  }

  generateParentChildrenTableMapping() {
    _forEach(this.childParentTableMapping, (values, key) => {
      _forEach(values, value => {
        if(value !== key) {
          put(this.parentChildTableMapping, `${value}[]`, key)
        }
      })
    })
  }

  ngOnDestroy(): void {
      this.tableCategoryVisibilityStrategy.clear();
  }
}
